import { h } from 'preact';
import { useContext, useEffect } from 'preact/hooks';
import { ApplicationContext } from 'contexts/use-application-setup';
import { stateStore } from 'global/state.store';
import { useConnect } from 'helpers/use-connect-to-global-store';
import { ABOUT_STATE } from 'constants/constants';
import { sessionStore } from 'global/session.store';
import { headerStore, HOME_TITLE } from 'global/header.store';
import { layoutStore } from 'global/layout.store';
import { OversizedWidget } from '../oversized-widget/oversized-widget';
import { Violations } from '../violations/violations';
import { Upgrade } from '../upgrade/upgrade';
import { remediationStore, Violations as ViolationsType } from '../../global/remediation.store';
import { LearnMoreButton } from '../learn-more-button/learn-more-button';
import { HowItWorksCta } from '../how-it-works/how-it-works-cta';
import { Profiles } from '../accessibility-features/profiles/profiles';
import { AllyFeaturesList } from '../accessibility-features/ally-features/ally-features-list';
import { MoveHide } from '../move-hide/move-hide';
import { LanguageSelector } from '../language-selector/language-selector';

export const InitialPageSections = () => {
  const config = useContext(ApplicationContext);
  const [_state, setState] = useConnect(stateStore.state);
  const [isLogged] = useConnect(sessionStore.isLogged$);
  const [isLoggedMember] = useConnect(sessionStore.isLoggedMember$);
  const [violations] = useConnect<ViolationsType>(remediationStore.violations$, null);

  const isUpgradeSectionVisible =
    isLogged && !isLoggedMember && !config?.paidProductsEnabled?.REMEDIATION && !config.paidAi;

  const isViolationSectionVisible =
    isLogged && !isLoggedMember && !config.paidAi && !!violations.totalCount;

  const isNoLogoTuning = config?.tunings?.widget_no_logo;

  useEffect(() => {
    // remove back state on home page
    headerStore.backState.next('');
    headerStore.title.next(HOME_TITLE);
    layoutStore.scrollTop(0, false);
  }, []);

  return (
    <div className="uwaw-initial-page">
      {isUpgradeSectionVisible && !isNoLogoTuning && (
        <LearnMoreButton onClick={() => setState(ABOUT_STATE)} />
      )}

      {!isNoLogoTuning && <HowItWorksCta />}

      {isViolationSectionVisible && <Violations />}

      {isUpgradeSectionVisible && !isViolationSectionVisible && <Upgrade />}

      <ul className="uwaw-options">
        <li className="uwaw-options__item">
          <LanguageSelector />
        </li>
        <li className="uwaw-options__item">
          <Profiles />
        </li>
        <li className="uwaw-options__item">
          <OversizedWidget />
        </li>
      </ul>

      <AllyFeaturesList />

      <MoveHide />
    </div>
  );
};
